var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1212 6.5H22.2186C22.2186 10.3329 25.4359 13.4527 29.3885 13.4527H32.33V16.1713C32.33 20.0042 35.5473 23.124 39.5 23.124V7.83705C39.5 7.07939 38.9025 6.5 38.1212 6.5Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2619 14.1657H14.3593C14.3593 17.9986 17.5766 21.1184 21.5292 21.1184H24.4708V23.8816C24.4708 27.7145 27.688 30.8342 31.6407 30.8342V15.5028C31.6407 14.7897 31.0432 14.1657 30.2619 14.1657Z",
    fill: "url(#paint0_linear_12115_71442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4026 21.876H6.5C6.5 25.7089 9.71729 28.8287 13.67 28.8287H16.6115V31.5473C16.6115 35.3802 19.8288 38.5 23.7814 38.5V23.2131C23.7814 22.4554 23.138 21.876 22.4026 21.876Z",
    fill: "url(#paint1_linear_12115_71442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12115_71442",
    x1: 38.854,
    y1: 6.57384,
    x2: 26.2813,
    y2: 19.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12115_71442",
    x1: 23.8851,
    y1: 21.9263,
    x2: 16.3018,
    y2: 29.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.197f3d202994e23ab605d2e682b8c9f6.svg";
export { ForwardRef as ReactComponent };